export interface TenantHeadInput {
  brandName: string;
  logoUrl: string;
  socialImageUrl?: string;
  origin: string;
}

export interface TenantHeadMetaEntry {
  name?: string;
  property?: string;
  content: string;
}

export interface TenantHeadLinkEntry {
  rel: string;
  href: string;
}

export interface TenantHead {
  title: string;
  meta: TenantHeadMetaEntry[];
  link: TenantHeadLinkEntry[];
}

export const NEUTRAL_DOCUMENT_TITLE = 'Launcher';

export const tenantHead = (
  input: TenantHeadInput,
  viewTitle = '',
): TenantHead => {
  const brand = input.brandName.trim();
  const logoUrl = input.logoUrl.trim();
  const socialImage = (input.socialImageUrl ?? '').trim() || logoUrl;
  const origin = input.origin.trim();
  const section = viewTitle.trim();

  const title = brand
    ? section
      ? `${section} | ${brand}`
      : brand
    : section || NEUTRAL_DOCUMENT_TITLE;

  if (!brand) return { title, meta: [], link: [] };

  const meta: TenantHeadMetaEntry[] = [
    { property: 'og:site_name', content: brand },
    { property: 'og:title', content: title },
    { property: 'og:type', content: 'website' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:card', content: 'summary' },
  ];

  if (origin) meta.push({ property: 'og:url', content: origin });
  if (socialImage) {
    meta.push({ property: 'og:image', content: socialImage });
    meta.push({ name: 'twitter:image', content: socialImage });
  }

  return {
    title,
    meta,
    link: logoUrl ? [{ rel: 'icon', href: logoUrl }] : [],
  };
};
